"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationsForCurrentLang = exports.getIsShowKeys = exports.getCurrentLang = exports.getAreTranslationsLoaded = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var i18nSelector = function i18nSelector(state) {
  return (0, _get2["default"])(state, 'i18n');
};
var getCurrentLang = exports.getCurrentLang = function getCurrentLang(state) {
  return (0, _get2["default"])(i18nSelector(state), 'currentLang');
};
var translationsSelector = function translationsSelector(state) {
  return (0, _get2["default"])(i18nSelector(state), 'translations');
};
var getAreTranslationsLoaded = exports.getAreTranslationsLoaded = function getAreTranslationsLoaded(state) {
  return !!translationsSelector(state);
};
var getTranslationsForCurrentLang = exports.getTranslationsForCurrentLang = function getTranslationsForCurrentLang(state) {
  return (0, _get2["default"])(translationsSelector(state), getCurrentLang(state));
};
var getIsShowKeys = exports.getIsShowKeys = function getIsShowKeys(state) {
  return !!(0, _get2["default"])(i18nSelector(state), 'showKeys');
};